import { queryFor } from "@visioni/a3s-client-api/app";
import { getAlarmConfigurationEndpoint, getScheduleHistoryEndpoint } from "../client-messages/alarms";
import { listNotificationPreferencesEndpoint } from "../client-messages/notification-preferences";
import { getContactPhoneNumberEndpoint } from "../client-messages/notification-contact-info";

/**
 * React Query options factory for the alarm configuration of a camera.
 * Usage: `alarmConfigurationQuery(apiConfig, pathParams)` inside `useQuery(...)`.
 */
export const alarmConfigurationQuery = queryFor(getAlarmConfigurationEndpoint);

/**
 * React Query options factory for the schedule history of a camera.
 * Usage: `alarmScheduleHistoryQuery(apiConfig, pathParams, { from, to })` inside `useQuery(...)`.
 */
export const alarmScheduleHistoryQuery = queryFor(getScheduleHistoryEndpoint);

/**
 * React Query options factory for the calling user's saved notification preferences.
 * Tenant-scoped with no extra path params — usage: `notificationPreferencesQuery(apiConfig, {})`.
 */
export const notificationPreferencesQuery = queryFor(listNotificationPreferencesEndpoint);

/**
 * React Query options factory for the calling user's saved contact phone number.
 * Tenant-scoped with no extra path params — usage: `contactPhoneNumberQuery(apiConfig, {})`.
 */
export const contactPhoneNumberQuery = queryFor(getContactPhoneNumberEndpoint);
